/**
 * Calculates the possible positions and sizes of the popover around the anchor.
 */
import { toClientRect } from "./rect-utils"
import getBoundingOffsets from "./getBoundingOffsets"

const getPositionOffsets = (
  elementRect: ClientRect,
  offsets: ReturnType<typeof getBoundingOffsets>
) => {
  const top = Math.max(offsets.top.top, offsets.top.bottom - elementRect.height)
  const left = Math.max(
    offsets.top.left,
    offsets.left.right - elementRect.width
  )
  const bottom = Math.min(
    offsets.bottom.bottom,
    offsets.bottom.top + elementRect.height
  )
  const right = Math.min(
    offsets.right.right,
    offsets.right.left + elementRect.width
  )
  return {
    ...offsets,
    top: toClientRect({
      top,
      left,
      height: offsets.top.bottom - top,
      width: right - left
    }),
    right: toClientRect({
      top,
      left: offsets.right.left,
      height: bottom - top,
      width: right - offsets.right.left
    }),
    bottom: toClientRect({
      top: offsets.bottom.top,
      left,
      height: Math.min(offsets.bottom.height, elementRect.height),
      width: right - left
    }),
    left: toClientRect({
      top,
      left,
      height: bottom - top,
      width: offsets.left.right - left
    })
  }
}

export default getPositionOffsets
